import logo from "./logo.svg";
import "./App.css";

function App() {
    return <div><h1>Souls Progress Tracker</h1></div>;
}

export default App;
